import useMessageDetailsGeneric, {
    MessageDetailsGenericResponse,
    MessageTrigger,
    type MessageAttachment,
    type Trigger,
} from './useMessageDetailsGeneric';

// Export re-usable types and constants
export { MessageTrigger };
export type { MessageAttachment, Trigger };

// Outbox-specific response type (alias to generic)
export interface MessageDetailsOutboxResponse extends MessageDetailsGenericResponse {}

/**
 * Hook for fetching outbox message details
 * This is a wrapper around useMessageDetailsGeneric for backward compatibility
 */
const useMessageDetailsOutboxApi = (messageId: string) => {
  return useMessageDetailsGeneric({ messageId, endpointType: 'outbox' });
};

export default useMessageDetailsOutboxApi;